import React from 'react';

import golfCourseSvg from '../assets/area-icons/golf-course.svg';
import onSiteDiningSvg from '../assets/area-icons/on-site-dining.svg';
import spaSvg from '../assets/area-icons/spa.svg';
import pickleballCourtSvg from '../assets/area-icons/pickleball-court.svg';
import specialEventsSvg from '../assets/area-icons/special-events-venue.svg';
import residentialBuildingSvg from '../assets/area-icons/residential-building.svg';
import diningRoomSvg from '../assets/area-icons/dining-room.svg';
import cafeSvg from '../assets/area-icons/cafe.svg';
import kitchenSvg from '../assets/area-icons/kitchen.svg';
import beverageCartSvg from '../assets/area-icons/beverage-cart.svg';
import eventHallSvg from '../assets/area-icons/event-hall.svg';
import clubAndLoungeSvg from '../assets/area-icons/club-and-lounge.svg';
import proShopSvg from '../assets/area-icons/pro-shop.svg';
import residenceSvg from '../assets/area-icons/residence.svg';
import commonAreasSvg from '../assets/area-icons/common-areas.svg';
import poolsideDiningSvg from '../assets/area-icons/poolside-dining.svg';

const AreaIcon = ({ onClick, src, alt, style, ...props }) => (
  <img
    src={src}
    alt={alt}
    onClick={onClick}
    style={{ cursor: 'pointer', width: '100%', height: 'auto', pointerEvents: 'visiblePainted', ...style }}
    {...props}
  />
);

// Main landing page icons
export const DiningIcon = (props) => (
  <AreaIcon src={onSiteDiningSvg} alt="On-site Dining" {...props} />
);

export const GolfIcon = (props) => (
  <AreaIcon src={golfCourseSvg} alt="Golf Course" {...props} />
);

export const SpaIcon = (props) => (
  <AreaIcon src={spaSvg} alt="Spa" {...props} />
);

export const PickleballIcon = (props) => (
  <AreaIcon src={pickleballCourtSvg} alt="Pickleball Court" {...props} />
);

export const SpecialEventsIcon = (props) => (
  <AreaIcon src={specialEventsSvg} alt="Special Events Venue" {...props} />
);

export const ResidentialIcon = (props) => (
  <AreaIcon src={residentialBuildingSvg} alt="Residential Building" {...props} />
);

// Sub-page map icons
export const DiningRoomIcon = (props) => (
  <AreaIcon src={diningRoomSvg} alt="Dining Room" {...props} />
);

export const CafeIcon = (props) => (
  <AreaIcon src={cafeSvg} alt="Cafe" {...props} />
);

export const KitchenIcon = (props) => (
  <AreaIcon src={kitchenSvg} alt="Kitchen" {...props} />
);

export const CartIcon = (props) => (
  <AreaIcon src={beverageCartSvg} alt="Beverage Cart" {...props} />
);

export const HallIcon = (props) => (
  <AreaIcon src={eventHallSvg} alt="Event Hall" {...props} />
);

export const ClubIcon = (props) => (
  <AreaIcon src={clubAndLoungeSvg} alt="Club & Lounge" {...props} />
);

export const ShopIcon = (props) => (
  <AreaIcon src={proShopSvg} alt="Pro Shop" {...props} />
);

export const ResidenceIcon = (props) => (
  <AreaIcon src={residenceSvg} alt="Residence" {...props} />
);

export const CommonAreasIcon = (props) => (
  <AreaIcon src={commonAreasSvg} alt="Common Areas" {...props} />
);

export const PoolsideIcon = (props) => (
  <AreaIcon src={poolsideDiningSvg} alt="Poolside Dining" {...props} />
);

export default AreaIcon;
